import { useQuery } from '@tanstack/react-query';
import { ScriptAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const scriptAPI = new ScriptAPI(axios);

export const useScriptActionsQuery = () => {
    return useQuery({
        queryKey: ['script/actions'],
        queryFn: async () => scriptAPI.getScriptActions(),
        staleTime: Infinity
    });
};
